<form class="coupon-field-container" [ngClass]="{ 'invalid': isInValid() }" (ngSubmit)="handleSubmit()">
  <input
    [disabled]="disabled()"
    class="coupon-input"
    type="text"
    [placeholder]="'Coupon Code'"
    [ariaLabel]="'Enter your coupon code'"
    [(ngModel)]="couponValue"
    [ngModelOptions]="{ standalone: true }"
  />
  <button
    [disabled]="disabled()"
    [ngClass]="{
          'button-accent-secondary': isOnModal() || !isPrimary(),
          'button-accent': !isOnModal() && isPrimary(),
          'apply-button': true,
      }"
    type="submit"
  >
    {{ 'shared_components.coupons.claim' | transloco}}
  </button>
</form>